<template>
  <div>
    <Accordion
      :is-open="false"
      class="pega-visible"
    >
      <template #head>
        絞り込み項目
      </template>
      <template #body>
        <div class="boss-layout boss-layout-vertical boss-layout-vertical-gap-large">
          <div>
            <div class="boss-table-3">
              <div class="boss-table-3-item">
                <div class="boss-table-3-head">
                  会員ID
                </div>
                <div class="boss-table-3-body" />
                <input
                  v-model.number="filterData.userId"
                  class="boss-input boss-input-fill"
                  data-test="input-user-id"
                  type="number"
                  :max="Number.MAX_SAFE_INTEGER"
                  min="0"
                  @keypress="onlyNumberInRange($event)"
                >
              </div>
              <div class="boss-table-3-item">
                <div class="boss-table-3-head">
                  氏名
                </div>
                <div class="boss-table-3-body">
                  <input
                    v-model="filterData.userName"
                    type="text"
                    class="boss-input boss-input-fill"
                    data-test="input-full-name"
                  >
                </div>
              </div>
              <div class="boss-table-3-item is-boss-only-pc">
                <div class="boss-table-3-head">
                  性別
                </div>
                <div class="boss-table-3-body">
                  <select
                    v-model="filterData.genderId"
                    class="boss-input-select"
                    data-test="select-gender"
                  >
                    <option value>
                      指定なし
                    </option>
                    <option
                      v-for="gender in genderMaster"
                      :key="gender.id"
                      :value="gender.id"
                    >
                      {{ gender.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="boss-table-3-item is-boss-only-pc">
                <div class="boss-table-3-head">
                  年齢
                </div>
                <div class="boss-table-3-body">
                  <select
                    v-model="ageGte"
                    class="boss-input-select"
                    data-test="select-age-gte"
                  >
                    <option value>
                      指定なし
                    </option>
                    <option
                      v-for="(age, i) in ageOptions"
                      :key="i"
                      :value="age"
                    >
                      {{ age }}
                    </option>
                  </select>
                  <span>歳</span>
                  〜
                  <select
                    v-model="ageLte"
                    class="boss-input-select"
                    data-test="select-age-lte"
                  >
                    <option value>
                      指定なし
                    </option>
                    <option
                      v-for="(age, i) in ageOptions"
                      :key="i"
                      :value="age"
                    >
                      {{ age }}
                    </option>
                  </select>
                  <span>歳</span>
                </div>
              </div>
              <div class="boss-table-3-item boss-table-3-item-size-2 is-boss-only-pc pega-visible">
                <div class="boss-table-3-head">
                  応募日
                </div>
                <div class="boss-table-3-body">
                  <date-picker
                    v-model="filterData.entryDate.gte"
                    type="date"
                    format="YYYY-MM-DD"
                    :disabled-date="notAfterTodayAndBeforeExpiryDate"
                    :editable="false"
                    input-class="pega-picker"
                    value-type="format"
                    data-test="data-picker-from"
                    placeholder="日付を選択"
                    :style="{ width: 'auto' }"
                    @clear="$set(filterData.entryDate,'gte' ,'')"
                  />
                  〜
                  <date-picker
                    v-model="filterData.entryDate.lte"
                    type="date"
                    format="YYYY-MM-DD"
                    :disabled-date="notAfterTodayAndBeforeExpiryDate"
                    :editable="false"
                    input-class="pega-picker"
                    value-type="format"
                    data-test="data-picker-to"
                    placeholder="日付を選択"
                    :style="{ width: 'auto' }"
                    @clear="$set(filterData.entryDate,'lte' ,'')"
                  />
                </div>
              </div>
              <div class="boss-table-3-item boss-table-3-item-size-2 is-boss-only-pc">
                <div class="boss-table-3-head">
                  求人ID
                </div>
                <div class="boss-table-3-body">
                  <select
                    v-model="filterData.conditionJobId"
                    class="boss-input-select"
                    data-test="select-job-ids"
                  >
                    <option value>
                      指定なし
                    </option>
                    <option
                      v-for="(id, i) in jobIds"
                      :key="i"
                      :value="id"
                    >
                      {{ id }}
                    </option>
                  </select>
                </div>
                <div class="boss-table-3-head padding-left-1">
                  応募した求人
                </div>
                <div class="boss-table-3-body">
                  <select
                    v-model="filterData.job"
                    v-tooltip="{ content: filterData.job.name }"
                    class="boss-input-select"
                    data-test="select-applied-jobs"
                  >
                    <option value>
                      指定なし
                    </option>
                    <option
                      v-for="(job, i) in appliedjobs"
                      :key="i"
                      :value="job"
                      :title="job.name"
                    >
                      {{ job | parseJobName }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="boss-table-3-item boss-table-3-item-size-1 grid-x">
                <div class="cell medium-12 large-6 display-flex align-middle pega-table-3-inner-item">
                  <div class="boss-table-3-head">
                    メッセージ予約
                  </div>
                  <div class="boss-table-3-body">
                    <div>
                      <label
                        class="pega-entry-list-search-checkbox-label"
                        data-test="no-select"
                      >
                        <input
                          v-model="filterData.message.isReserved"
                          :value="''"
                          type="radio"
                          class="boss-input-checkbox"
                          data-test="no-select-check"
                        >指定なし
                      </label>
                      <label
                        class="pega-entry-list-search-checkbox-label"
                        data-test="not-reserved"
                      >
                        <input
                          v-model="filterData.message.isReserved"
                          :value="false"
                          type="radio"
                          class="boss-input-checkbox"
                          data-test="not-reserved-check"
                        >予約中を除く
                      </label>
                      <label
                        class="pega-entry-list-search-checkbox-label"
                        data-test="is-reserved"
                      >
                        <input
                          v-model="filterData.message.isReserved"
                          :value="true"
                          type="radio"
                          class="boss-input-checkbox"
                          data-test="is-reserved-check"
                        >予約中のみ
                      </label>
                    </div>
                  </div>
                </div>
                <div class="cell auto display-flex align-middle">
                  <div class="boss-table-3-head">
                    応募・メッセージ
                  </div>
                  <div class="boss-table-3-body">
                    <div>
                      <label
                        class="pega-entry-list-search-checkbox-label"
                        data-test="select-message-unread"
                      >
                        <input
                          v-model="filterData.message.isUnread"
                          type="checkbox"
                          class="boss-input-checkbox"
                        >
                        <span>未読</span>
                      </label>
                      <label
                        class="pega-entry-list-search-checkbox-label"
                        data-test="select-message-not-replied"
                      >
                        <input
                          v-model="filterData.message.isNotReplied"
                          type="checkbox"
                          class="boss-input-checkbox"
                        >
                        <span>未返信</span>
                      </label>
                      <label
                        class="pega-entry-list-search-checkbox-label"
                        data-test="select-message-replied"
                      >
                        <input
                          v-model="filterData.message.isReplied"
                          type="checkbox"
                          class="boss-input-checkbox"
                        >
                        <span>返信済み</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="boss-table-3-item boss-table-3-item-size-1">
                <div class="boss-table-3-head">
                  スカウト特典
                </div>
                <div class="boss-table-3-body">
                  <span data-test="special-favor-effective">
                    <label><input
                      v-model="filterData.isSpecialFavorEffectiveOnly"
                      type="checkbox"
                      class="boss-input-checkbox"
                    >応募期限内の特典のみ</label>
                  </span>
                  <label
                    v-for="(option ,i) in specialFavorsMaster"
                    :key="i"
                    :data-test="`special-favor-${option.id}`"
                    class="boss-scout-bonus pega-mr-5 pega-input"
                  >
                    <input
                      v-model="filterData.checkedSpecialFavorIds"
                      :value="option.id"
                      type="checkbox"
                    >
                    <span class="boss-bonus-check-text boss-bonus-check-mark">{{ option.name }}</span>
                  </label>
                </div>
              </div>
              <div class="boss-table-3-item boss-table-3-item-size-1 is-boss-only-pc">
                <div class="boss-table-3-head">
                  選考フェーズ
                </div>
                <div class="boss-table-3-body">
                  <label
                    v-for="(option, i) in phases"
                    :key="i"
                    class="pega-entry-list-search-checkbox-label"
                    :data-test="`select-phase-${option.id}`"
                  >
                    <input
                      v-model="filterData.currentSelection.phaseIds"
                      :value="option.id"
                      type="checkbox"
                      class="boss-input-checkbox"
                    >
                    <span>{{ option.name }}</span>
                  </label>
                </div>
              </div>
              <div class="boss-table-3-item boss-table-3-item-size-1 is-boss-only-pc">
                <div class="boss-table-3-head">
                  選考ステータス
                </div>
                <div class="boss-table-3-body">
                  <label
                    class="pega-entry-list-search-checkbox-label"
                    :data-test="'select-status-0'"
                  >
                    <input
                      v-model="filterData.currentSelection.statusIds"
                      :value="null"
                      type="checkbox"
                      class="boss-input-checkbox"
                    >
                    <span>−</span>
                  </label>
                  <label
                    v-for="(option, i) in statuses"
                    :key="i"
                    class="pega-entry-list-search-checkbox-label"
                    :data-test="`select-status-${option.id}`"
                  >
                    <input
                      v-model="filterData.currentSelection.statusIds"
                      :value="option.id"
                      type="checkbox"
                      class="boss-input-checkbox"
                    >
                    <span>{{ option.name }}</span>
                  </label>
                </div>
              </div>
              <div class="boss-table-3-item boss-table-3-item-size-1 is-boss-only-pc">
                <div class="boss-table-3-head">
                  評価
                </div>
                <div class="boss-table-3-body">
                  <label
                    class="pega-entry-list-search-checkbox-label"
                    :data-test="'select-evaluation-0'"
                  >
                    <input
                      v-model="filterData.currentSelection.evaluationIds"
                      :value="null"
                      type="checkbox"
                      class="boss-input-checkbox"
                    >
                    <span>−</span>
                  </label>
                  <label
                    v-for="(option, i) in evaluationMaster"
                    :key="i"
                    class="pega-entry-list-search-checkbox-label"
                    :data-test="`select-evaluation-${option.id}`"
                  >
                    <input
                      v-model="filterData.currentSelection.evaluationIds"
                      :value="option.id"
                      type="checkbox"
                      class="boss-input-checkbox"
                    >
                    <span>{{ option.name }}</span>
                  </label>
                </div>
              </div>
              <div class="boss-table-3-item is-boss-only-pc">
                <div class="boss-table-3-head">
                  人事担当
                </div>
                <div class="boss-table-3-body">
                  <select
                    v-model="filterData.responsibleStaffId"
                    class="boss-input-select"
                    data-test="select-responsible-staffs"
                  >
                    <option value>
                      指定なし
                    </option>
                    <option :value="null">
                      −
                    </option>
                    <option
                      v-for="staff in responsibles"
                      :key="staff.id"
                      :value="staff.id"
                    >
                      {{ staff.name | parseStaffName }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="boss-table-3-item is-boss-only-pc">
                <div class="boss-table-3-head">
                  <input
                    id="duplicated-entry-check"
                    v-model="filterData.isDuplicatedEntries"
                    type="checkbox"
                    class="boss-input-checkbox"
                    false-value=""
                    data-test="check-duplicated"
                  >
                </div>
                <div class="boss-table-3-body">
                  <label
                    for="duplicated-entry-check"
                    class="pega-input"
                  >重複応募者のみ</label>
                </div>
                <div class="boss-table-3-head margin-left-1">
                  <input
                    id="withdraw-entry-check"
                    v-model="filterData.isWithdrawal"
                    type="checkbox"
                    false-value=""
                    class="boss-input-checkbox"
                    data-test="check-withdraw"
                  >
                </div>
                <div class="boss-table-3-body">
                  <label
                    for="withdraw-entry-check"
                    class="pega-input"
                  >応募後に退会した会員のみ表示</label>
                </div>
              </div>
            </div>
          </div>
          <div class="is-boss-only-pc">
            <MiniAccordion
              :is-open="false"
              title="さらに絞り込む"
              wrap-class="boss-mini-accordion-plain"
              head-class="boss-mini-accordion-head-custom-2 boss-accordion-head"
            >
              <div class="boss-table-3">
                <div class="boss-table-3-item boss-table-3-item-size-2 pega-alien-base">
                  <div class="boss-table-3-head">
                    現住所
                  </div>
                  <div class="boss-table-3-body">
                    <select-modal-button
                      v-if="prefecturesOnlyMaster.length > 0"
                      :master-data="prefecturesOnlyMaster"
                      :selected-items="modalSelected('filterData', 'currentPrefectureIds')"
                      title="都道府県"
                      suffix="current-prefectures"
                      data-test="modal-current-prefectures"
                      @update-modal-checked-ids="updateModalItems($event, 'currentPrefectureIds')"
                    />
                  </div>
                </div>
                <div class="boss-table-3-item boss-table-3-item-size-2 pega-alien-base">
                  <div class="boss-table-3-head">
                    希望勤務地
                  </div>
                  <div class="boss-table-3-body">
                    <select-modal-button
                      v-if="prefecturesOnlyMaster.length > 0"
                      :master-data="prefecturesOnlyMaster"
                      :selected-items="modalSelected('filterData', 'desiredWorkPrefectureIds')"
                      title="都道府県"
                      suffix="hope-prefectures"
                      data-test="modal-hope-prefectures"
                      @update-modal-checked-ids="updateModalItems($event, 'desiredWorkPrefectureIds')"
                    />
                  </div>
                </div>
                <div class="boss-table-3-item boss-table-3-item-size-2 pega-alien-base">
                  <div class="boss-table-3-head">
                    経験職種
                  </div>
                  <div class="boss-table-3-body">
                    <select-modal-button
                      v-if="occupationsMaster.length > 0"
                      :master-data="occupationsMaster"
                      :selected-items="modalSelected('filterData', 'experienceOccupationIds')"
                      title="経験職種"
                      suffix="occupations"
                      data-test="modal-occupations"
                      @update-modal-checked-ids="updateModalItems($event, 'experienceOccupationIds')"
                    />
                  </div>
                </div>
                <div class="boss-table-3-item boss-table-3-item-size-2 pega-alien-base">
                  <div class="boss-table-3-head">
                    経験業種
                  </div>
                  <div class="boss-table-3-body">
                    <select-modal-button
                      v-if="businessesMaster.length > 0"
                      :master-data="businessesMaster"
                      :selected-items="modalSelected('filterData', 'experienceBusinessIds')"
                      title="経験業種"
                      suffix="businesses"
                      data-test="modal-businesses"
                      @update-modal-checked-ids="updateModalItems($event, 'experienceBusinessIds')"
                    />
                  </div>
                </div>
                <div class="boss-table-3-item boss-table-3-item-size-2">
                  <div class="boss-table-3-head">
                    直近の雇用形態
                  </div>
                  <div class="boss-table-3-body">
                    <select
                      v-model="filterData.employmentId"
                      class="boss-input-select"
                      data-test="select-employment-pattern"
                    >
                      <option value="">
                        指定なし
                      </option>
                      <option
                        v-for="(option, i) in employmentStatusMaster"
                        :key="i"
                        :value="option.id"
                      >
                        {{ option.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="boss-table-3-item boss-table-3-item-size-2">
                  <div class="boss-table-3-head">
                    現在の就業状況
                  </div>
                  <div class="boss-table-3-body">
                    <select
                      v-model="filterData.isWorking"
                      class="boss-input-select"
                      data-test="select-employed"
                    >
                      <option value="">
                        指定なし
                      </option>
                      <option
                        v-for="(option, i) in employedOptions"
                        :key="i"
                        :value="option.value"
                      >
                        {{ option.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="boss-table-3-item boss-table-3-item-size-2">
                  <div class="boss-table-3-head">
                    最終学歴学校名
                  </div>
                  <div class="boss-table-3-body">
                    <input
                      v-model="filterData.lastEducationName"
                      type="text"
                      style="width: 12em;"
                      class="boss-input"
                      data-test="input-school-name"
                    >
                  </div>
                </div>
                <div class="boss-table-3-item boss-table-3-item-size-2">
                  <div class="boss-table-3-head">
                    転職回数
                  </div>
                  <div class="boss-table-3-body">
                    <input
                      v-model.number="filterData.jobChangeCount"
                      style="width: 6em;"
                      class="boss-input"
                      data-test="input-job-change-count"
                      type="number"
                      :max="Number.MAX_SAFE_INTEGER"
                      min="0"
                      @keypress="onlyNumberInRange($event)"
                    > 回以下
                  </div>
                </div>
                <div class="boss-table-3-item boss-table-3-item-size-3">
                  <div class="boss-table-3-head">
                    直近の年収
                  </div>
                  <div class="boss-table-3-body">
                    <input
                      v-model.number="filterData.recentSalary.gte"
                      style="width: 6em;"
                      data-test="input-recent-salary-minimum"
                      class="boss-input"
                      type="number"
                      :max="Number.MAX_SAFE_INTEGER"
                      min="0"
                      @keypress="onlyNumberInRange($event)"
                    > 万円
                    〜
                    <input
                      v-model.number="filterData.recentSalary.lte"
                      style="width: 6em;"
                      data-test="input-recent-salary-maximum"
                      class="boss-input"
                      type="number"
                      :max="Number.MAX_SAFE_INTEGER"
                      min="0"
                      @keypress="onlyNumberInRange($event)"
                    > 万円
                  </div>
                </div>
                <div class="boss-table-3-item boss-table-3-item-size-3">
                  <div class="boss-table-3-head">
                    希望の年収
                  </div>
                  <div class="boss-table-3-body">
                    <input
                      v-model.number="filterData.desiredSalary.gte"
                      style="width: 6em;"
                      data-test="input-hope-salary-minimum"
                      class="boss-input"
                      type="number"
                      :max="Number.MAX_SAFE_INTEGER"
                      min="0"
                      @keypress="onlyNumberInRange($event)"
                    > 万円
                    〜
                    <input
                      v-model.number="filterData.desiredSalary.lte"
                      style="width: 6em;"
                      data-test="input-hope-salary-maximum"
                      class="boss-input"
                      type="number"
                      :max="Number.MAX_SAFE_INTEGER"
                      min="0"
                      @keypress="onlyNumberInRange($event)"
                    > 万円
                  </div>
                </div>
                <div class="boss-table-3-item boss-table-3-item-size-3">
                  <div class="boss-table-3-head">
                    最終学歴
                  </div>
                  <div class="boss-table-3-body">
                    <select
                      v-model.number="filterData.lastEducationId"
                      class="boss-input-select"
                      data-test="select-education"
                    >
                      <option value="">
                        指定なし
                      </option>
                      <option
                        v-for="(education, i) in educationalBackgroundMaster"
                        :key="i"
                        :value="education.id"
                      >
                        {{ education.name }}
                      </option>
                    </select> 以上
                  </div>
                </div>
                <div class="boss-table-3-item boss-table-3-item-size-3">
                  <div class="boss-table-3-head">
                    TOEIC
                  </div>
                  <div class="boss-table-3-body">
                    <input
                      v-model.number="filterData.toeic"
                      style="width: 6em;"
                      data-test="input-toeic"
                      class="boss-input"
                      type="number"
                      :max="Number.MAX_SAFE_INTEGER"
                      min="0"
                      @keypress="onlyNumberInRange($event, 990)"
                    > 点以上
                  </div>
                </div>
                <div class="boss-table-3-item boss-table-3-item-size-3">
                  <div class="boss-table-3-head">
                    TOEFL
                  </div>
                  <div class="boss-table-3-body">
                    <input
                      v-model.number="filterData.toefl"
                      style="width: 6em;"
                      data-test="input-toefl"
                      class="boss-input"
                      type="number"
                      :max="Number.MAX_SAFE_INTEGER"
                      min="0"
                      @keypress="onlyNumberInRange($event, 677)"
                    > 点以上
                  </div>
                </div>
                <div class="boss-table-3-item boss-table-3-item-size-3">
                  <div class="boss-table-3-head">
                    英語スキル
                  </div>
                  <div class="boss-table-3-body">
                    <select
                      v-model.number="filterData.englishSkillId"
                      class="boss-input-select"
                      data-test="select-english-skill"
                    >
                      <option value="">
                        指定なし
                      </option>
                      <option
                        v-for="(englishSkill, i) in languageSkillsMaster"
                        :key="i"
                        :value="englishSkill.id"
                      >
                        {{ englishSkill.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="boss-table-3-item boss-table-3-item-size-2">
                  <div class="boss-table-3-head">
                    資格
                  </div>
                  <div class="boss-table-3-body">
                    <select-modal-button
                      v-if="licensesMaster.length > 0"
                      :master-data="licensesMaster"
                      :selected-items="modalSelected('filterData', 'licenses')"
                      title="資格"
                      suffix="licenses"
                      data-test="modal-licenses"
                      @update-modal-checked-ids="updateModalItems($event, 'licenses')"
                    />
                  </div>
                </div>
                <div class="boss-table-3-item boss-table-3-item-size-2">
                  <div class="boss-table-3-head">
                    スキル
                  </div>
                  <div class="boss-table-3-body">
                    <div class="boss-layout boss-layout-start boss-layout-gap-large">
                      <label
                        class="pega-input"
                      >AND検索する
                        <input
                          v-model="filterData.isCheckedAndSearchSkill"
                          type="checkbox"
                          class="boss-input-checkbox"
                          false-value=""
                          data-test="check-and-search-skill"
                        >
                      </label>
                    </div>
                    <select-modal-button
                      v-if="skillsMaster.length > 0"
                      :master-data="skillsMasterForShowingArray"
                      :experience-range-options="experienceOptions"
                      :default-experience-id="defaultExperienceId"
                      :selected-items="modalSelected('filterData', 'skills')"
                      title="スキル"
                      suffix="skills"
                      data-test="modal-skills"
                      @update-modal-checked-ids="updateModalObjects($event, 'skills')"
                    />
                  </div>
                </div>
                <div class="boss-table-3-item boss-table-3-item-size-3">
                  <div class="boss-table-3-head">
                    未既婚
                  </div>
                  <div class="boss-table-3-body">
                    <select
                      v-model="filterData.married"
                      class="boss-input-select"
                      data-test="select-married"
                    >
                      <option value="">
                        指定なし
                      </option>
                      <option
                        v-for="(option, i) in marriedOptions"
                        :key="i"
                        :value="option.value"
                      >
                        {{ option.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="boss-table-3-item boss-table-3-item-size-3">
                  <div class="boss-table-3-head">
                    子供有無
                  </div>
                  <div class="boss-table-3-body">
                    <select
                      v-model="filterData.hasChild"
                      class="boss-input-select"
                      data-test="select-has-child"
                    >
                      <option value="">
                        指定なし
                      </option>
                      <option
                        v-for="(option, i) in childStatusOptions"
                        :key="i"
                        :value="option.value"
                      >
                        {{ option.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="boss-table-3-item boss-table-3-item-size-3">
                  <div class="boss-table-3-head">
                    転居を伴う転職可否
                  </div>
                  <div class="boss-table-3-body">
                    <select
                      v-model="filterData.canHomeMoving"
                      class="boss-input-select"
                      data-test="select-can-home-moving"
                    >
                      <option value="">
                        指定なし
                      </option>
                      <option
                        v-for="(option, i) in homeMovingStatusOptions"
                        :key="i"
                        :value="option.value"
                      >
                        {{ option.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </MiniAccordion>
          </div>
        </div>
      </template>
    </Accordion>
  </div>
</template>

<script>
import Accordion from '@/components/atoms/Accordion'
import MiniAccordion from '@/components/atoms/MiniAccordion'
import _ from 'lodash'
import * as definition from '@/lib/labelValueMappings'
import dayjs from 'dayjs'
import { mapGetters } from 'vuex'
import SelectModalButton from '@/components/organisms/SelectModalButton'
import DatePicker from 'vue2-datepicker'
import eventValidations from '@/lib/eventValidations'

export default {
  components: {
    Accordion,
    MiniAccordion,
    SelectModalButton,
    DatePicker
  },
  filters: {
    parseJobName (job) {
      return _.truncate(`${job.id} ${job.name}`, { length: 23 })
    },
    parseStaffName (staffName) {
      return _.truncate(staffName, { length: 13 })
    }
  },
  mixins: [eventValidations],
  props: {
    entryObjects: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      filterData: {
        userId: '',
        userName: '',
        genderId: '',
        birthday: {
          gte: '',
          lte: ''
        },
        entryDate: {
          gte: '',
          lte: ''
        },
        conditionJobId: '',
        job: '',
        message: {
          isUnread: false,
          isNotReplied: false,
          isReplied: false,
          isReserved: ''
        },
        isSpecialFavorEffectiveOnly: false,
        checkedSpecialFavorIds: [],
        currentSelection: {
          phaseIds: [],
          statusIds: [],
          evaluationIds: []
        },
        responsibleStaffId: '',
        isDuplicatedEntries: false,
        isWithdrawal: false,
        currentPrefectureIds: [],
        desiredWorkPrefectureIds: [],
        experienceOccupationIds: [],
        experienceBusinessIds: [],
        employmentId: '',
        isWorking: '',
        lastEducationName: '',
        jobChangeCount: '',
        recentSalary: {
          gte: '',
          lte: ''
        },
        desiredSalary: {
          gte: '',
          lte: ''
        },
        lastEducationId: '',
        toeic: '',
        toefl: '',
        englishSkillId: '',
        canHomeMoving: '',
        married: '',
        hasChild: '',
        licenses: [],
        skills: [],
        isCheckedAndSearchSkill: false
      },
      ageOptions: definition.age,
      employedOptions: definition.entryEmployed,
      specialFavorOptions: definition.hasSpecialFavorsOrNot,
      homeMovingStatusOptions: definition.entryHomeMovingStatus,
      marriedOptions: definition.entryMarried,
      childStatusOptions: definition.entryChildStatus,
      experienceOptions: definition.entrySkillExperienceRange
    }
  },
  computed: {
    appliedjobs () {
      return this.pickEntryProperty('job')
    },
    jobIds () {
      return this.pickEntryProperty('job.id')
    },
    ageGte: {
      get () {
        if (!this.filterData.birthday.lte) { return '' }
        return _.defaultTo(dayjs().diff(dayjs(this.filterData.birthday.lte), 'years'), '')
      },
      set (val) {
        this.filterData.birthday.lte = (val) ? dayjs().subtract(val, 'years').format('YYYY-MM-DD') : ''
      }
    },
    ageLte: {
      get () {
        if (!this.filterData.birthday.gte) { return '' }
        return _.defaultTo(dayjs().diff(dayjs(this.filterData.birthday.gte), 'years'), '')
      },
      set (val) {
        this.filterData.birthday.gte = (val) ? dayjs().subtract(val + 1, 'years').add(1, 'days').format('YYYY-MM-DD') : ''
      }
    },
    defaultExperienceId () {
      return _.head(this.experienceOptions).id
    },
    ...mapGetters('settings', [
      'phases',
      'statuses',
      'responsibles'
    ]),
    ...mapGetters([
      'prefecturesOnlyMaster',
      'businessesMaster',
      'occupationsMaster',
      'genderMaster',
      'employmentStatusMaster',
      'educationalBackgroundMaster',
      'languageSkillsMaster',
      'evaluationMaster',
      'specialFavorsMaster',
      'licensesMaster',
      'skillsMaster'
    ]),
    skillsMasterForShowingArray () {
      // スキルマスターは2層目と3層目が同一内容になっているため、3層目を省いて利用する
      return this.skillsMaster.map(lv1 => {
        return {
          id: lv1.id,
          name: lv1.name,
          children: lv1.children.map(lv2 => {
            return {
              id: lv2.id,
              name: lv2.name,
              // 3層目を省略して2層目の子に4層目を繋げる
              // 2層目対3層目(lv2.children)は必ず1:1になる。
              children: lv2.children[0].children
            }
          })
        }
      })
      // 簡易例：{1層目:{2層目:{3層目:{4層目}}}} → {1層目:{2層目:{4層目}}}
    }
  },
  watch: {
    filterData: {
      handler: 'update',
      deep: true
    },
    entryObjects: {
      handler: 'update'
    }
  },
  methods: {
    update () {
      // shouldFilter:絞り込み条件がするかどうか filterFunction: 絞り込みの処理
      const filters = [
        { shouldFilter: _.get(this.filterData, 'userId'), filterFunction: this.filterUserId },
        { shouldFilter: _.get(this.filterData, 'userName'), filterFunction: this.filterUserName },
        { shouldFilter: _.get(this.filterData, 'genderId'), filterFunction: this.filterGender },
        { shouldFilter: _.get(this.filterData, 'birthday.gte'), filterFunction: this.filterAgeGte },
        { shouldFilter: _.get(this.filterData, 'birthday.lte'), filterFunction: this.filterAgeLte },
        { shouldFilter: _.get(this.filterData, 'entryDate.gte'), filterFunction: this.filterEntryDateGte },
        { shouldFilter: _.get(this.filterData, 'entryDate.lte'), filterFunction: this.filterEntryDateLte },
        { shouldFilter: _.get(this.filterData, 'conditionJobId'), filterFunction: this.filterConditionJobId },
        { shouldFilter: _.get(this.filterData, 'job'), filterFunction: this.filterJob },
        { shouldFilter: _.isBoolean(_.get(this.filterData, 'message.isReserved')), filterFunction: this.filterIsReserved },
        { shouldFilter: (_.get(this.filterData, 'message.isUnread') || _.get(this.filterData, 'message.isNotReplied') || _.get(this.filterData, 'message.isReplied')), filterFunction: this.filterMessage },
        { shouldFilter: _.get(this.filterData, 'checkedSpecialFavorIds').length, filterFunction: this.filterCheckedSpecialFavor },
        { shouldFilter: _.get(this.filterData, 'currentSelection.phaseIds').length, filterFunction: this.filterPhase },
        { shouldFilter: _.get(this.filterData, 'currentSelection.statusIds').length, filterFunction: this.filterStatus },
        { shouldFilter: _.get(this.filterData, 'currentSelection.evaluationIds').length, filterFunction: this.filterEvaluation },
        { shouldFilter: _.get(this.filterData, 'responsibleStaffId') !== '', filterFunction: this.filterResponsibleStaff },
        { shouldFilter: _.get(this.filterData, 'isDuplicatedEntries'), filterFunction: this.filterDuplicatedEntries },
        { shouldFilter: _.get(this.filterData, 'isWithdrawal'), filterFunction: this.filterWithdrawal },
        { shouldFilter: _.get(this.filterData, 'currentPrefectureIds').length, filterFunction: this.filterCurrentPrefecture },
        { shouldFilter: _.get(this.filterData, 'desiredWorkPrefectureIds').length, filterFunction: this.filterDesiredWorkPrefecture },
        { shouldFilter: _.get(this.filterData, 'experienceOccupationIds').length, filterFunction: this.filterExperienceOccupation },
        { shouldFilter: _.get(this.filterData, 'experienceBusinessIds').length, filterFunction: this.filterExperienceBusiness },
        { shouldFilter: _.get(this.filterData, 'employmentId'), filterFunction: this.filterEmployment },
        { shouldFilter: _.isBoolean(_.get(this.filterData, 'isWorking')), filterFunction: this.filterIsWorking },
        { shouldFilter: _.get(this.filterData, 'lastEducationName'), filterFunction: this.filterLastEducationName },
        { shouldFilter: _.isNumber(_.get(this.filterData, 'jobChangeCount')), filterFunction: this.filterJobChangeCount },
        { shouldFilter: _.isNumber(_.get(this.filterData, 'recentSalary.gte')), filterFunction: this.filterRecentSalaryGte },
        { shouldFilter: _.isNumber(_.get(this.filterData, 'recentSalary.lte')), filterFunction: this.filterRecentSalaryLte },
        { shouldFilter: _.isNumber(_.get(this.filterData, 'desiredSalary.gte')), filterFunction: this.filterDesiredSalaryGte },
        { shouldFilter: _.isNumber(_.get(this.filterData, 'desiredSalary.lte')), filterFunction: this.filterDesiredSalaryLte },
        { shouldFilter: _.get(this.filterData, 'lastEducationId'), filterFunction: this.filterLastEducationId },
        { shouldFilter: _.isNumber(_.get(this.filterData, 'toeic')), filterFunction: this.filterToeic },
        { shouldFilter: _.isNumber(_.get(this.filterData, 'toefl')), filterFunction: this.filterToefl },
        { shouldFilter: _.get(this.filterData, 'englishSkillId'), filterFunction: this.filterEnglishSkillId },
        { shouldFilter: _.isBoolean(_.get(this.filterData, 'canHomeMoving')), filterFunction: this.filterCanHomeMoving },
        { shouldFilter: _.isBoolean(_.get(this.filterData, 'married')), filterFunction: this.filterMarried },
        { shouldFilter: _.isBoolean(_.get(this.filterData, 'hasChild')), filterFunction: this.filterHasChild },
        { shouldFilter: _.get(this.filterData, 'licenses').length, filterFunction: this.filterLicense },
        { shouldFilter: _.get(this.filterData, 'skills').length, filterFunction: this.filterSkills },
        { shouldFilter: _.get(this.filterData, 'isCheckedAndSearchSkill'), filterFunction: this.filterSkills }
      ]

      const hasFilter = !!filters.filter(filter => filter.shouldFilter).length

      const filterFunctions = _.overEvery(filters.filter(filter => filter.shouldFilter).map(filter => filter.filterFunction))
      this.entryObjects.forEach(entryObject => {
        entryObject.isShow = hasFilter ? filterFunctions(entryObject.entry) : true
        entryObject.isChecked = false
      })

      this.$emit('filteredUpdate', this.entryObjects)
    },
    filterUserId (entry) {
      return !!String(_.get(entry, 'user.id')).match('^' + _.get(this.filterData, 'userId'))
    },
    filterUserName (entry) {
      return [
        this.hiraToKana(`${_.get(entry, 'user.lastName', '')}${_.get(entry, 'user.firstName', '')}`),
        `${_.get(entry, 'user.lastNameKana', '')}${_.get(entry, 'user.firstNameKana', '')}`
      ].some(name => _.includes(name, this.hiraToKana(_.get(this.filterData, 'userName'))))
    },
    filterGender (entry) {
      return _.get(entry, 'user.gender.id') === _.get(this.filterData, 'genderId')
    },
    filterAgeGte (entry) {
      return dayjs(_.get(entry, 'user.birthday')).isSameOrAfter(dayjs(_.get(this.filterData, 'birthday.gte')), 'day')
    },
    filterAgeLte (entry) {
      return dayjs(_.get(entry, 'user.birthday')).isSameOrBefore(dayjs(_.get(this.filterData, 'birthday.lte')), 'day')
    },
    filterEntryDateGte (entry) {
      return dayjs(_.get(entry, 'entryDate')).isSameOrAfter(dayjs(_.get(this.filterData, 'entryDate.gte')), 'day')
    },
    filterEntryDateLte (entry) {
      return dayjs(_.get(entry, 'entryDate')).isSameOrBefore(dayjs(_.get(this.filterData, 'entryDate.lte')), 'day')
    },
    filterConditionJobId (entry) {
      return _.get(entry, 'job.id') === _.get(this.filterData, 'conditionJobId')
    },
    filterJob (entry) {
      return _.isEqual(_.get(entry, 'job'), _.get(this.filterData, 'job'))
    },
    filterIsReserved (entry) {
      return _.get(entry, 'isEntryMessageReservationReserved') === _.get(this.filterData, 'message.isReserved')
    },
    filterMessage (entry) {
      // OR条件のため、1つでもマッチしていればtrue
      // - 未読
      const isUnread = _.get(this.filterData, 'message.isUnread')
      if (isUnread && (!_.get(entry, 'isRead') || !_.get(entry, 'message.isRead'))) return true

      // - 未返信
      const isNotReplied = _.get(this.filterData, 'message.isNotReplied')
      if (isNotReplied && !_.get(entry, 'message.isReplied')) return true

      // - 返信済み
      const isReplied = _.get(this.filterData, 'message.isReplied')
      if (isReplied && _.get(entry, 'message.isReplied')) return true

      return false
    },
    filterCheckedSpecialFavor (entry) {
      // 画面からチェックされたスカウト特典IDのリスト
      const checkedIds = _.get(this.filterData, 'checkedSpecialFavorIds')
      // 応募が持っているスカウト特典のオブジェクトリスト
      const specialFavors = _.get(entry, 'approachingStatus.specialFavors', [])
      // チェックされたスカウト特典のうち１つでもあればその応募者を表示
      // (応募期限内の特典のみにチェックを付けた場合は有効なスカウト特典のみで絞り込み)
      if (_.get(this.filterData, 'isSpecialFavorEffectiveOnly')) {
        return specialFavors
          .filter(specialFavor => specialFavor.isEffective)
          .some(specialFavor => checkedIds.includes(specialFavor.id))
      } else {
        return specialFavors
          .some(specialFavor => checkedIds.includes(specialFavor.id))
      }
    },
    filterPhase (entry) {
      return _.get(this.filterData, 'currentSelection.phaseIds').some(phaseId =>
        phaseId === _.get(entry, 'currentSelection.phaseId')
      )
    },
    filterStatus (entry) {
      return _.get(this.filterData, 'currentSelection.statusIds').some(statusId =>
        statusId === _.get(entry, 'currentSelection.statusId')
      )
    },
    filterEvaluation (entry) {
      return _.get(this.filterData, 'currentSelection.evaluationIds').some(evaluationId =>
        evaluationId === _.get(entry, 'currentSelection.evaluation.id', null)
      )
    },
    filterResponsibleStaff (entry) {
      return _.get(entry, 'responsibleStaffId') === _.get(this.filterData, 'responsibleStaffId')
    },
    filterDuplicatedEntries (entry) {
      return _.get(entry, 'user.isDuplicatedEntries')
    },
    filterWithdrawal (entry) {
      return _.get(entry, 'user.isWithdrawal')
    },
    filterCurrentPrefecture (entry) {
      return _.get(this.filterData, 'currentPrefectureIds')
        .some(selectedId => selectedId === _.get(entry, 'user.prefecture.id'))
    },
    filterDesiredWorkPrefecture (entry) {
      return _.get(this.filterData, 'desiredWorkPrefectureIds')
        .some(selectedId => _.includes(_.get(entry, 'user.desiredWorkPrefectureIds'), selectedId))
    },
    filterExperienceOccupation (entry) {
      return _.get(this.filterData, 'experienceOccupationIds')
        .some(selectedId => _.includes(_.get(entry, 'user.experienceOccupationIds'), selectedId))
    },
    filterExperienceBusiness (entry) {
      return _.get(this.filterData, 'experienceBusinessIds')
        .some(selectedId => _.includes(_.get(entry, 'user.experienceBusinessIds'), selectedId))
    },
    filterEmployment (entry) {
      return _.get(entry, 'user.employmentId') === _.get(this.filterData, 'employmentId')
    },
    filterIsWorking (entry) {
      return _.get(entry, 'user.isWorking') === _.get(this.filterData, 'isWorking')
    },
    filterLastEducationName (entry) {
      return _.includes(
        _.get(entry, 'user.lastEducationName'),
        _.get(this.filterData, 'lastEducationName')
      )
    },
    filterJobChangeCount (entry) {
      return _.isNumber(_.get(entry, 'user.jobChangeCount'))
        ? _.get(this.filterData, 'jobChangeCount') >= _.get(entry, 'user.jobChangeCount')
        : false
    },
    filterRecentSalaryGte (entry) {
      return _.isNumber(_.get(entry, 'user.recentSalary'))
        ? _.get(this.filterData, 'recentSalary.gte') <= _.get(entry, 'user.recentSalary')
        : false
    },
    filterRecentSalaryLte (entry) {
      return _.isNumber(_.get(entry, 'user.recentSalary'))
        ? _.get(this.filterData, 'recentSalary.lte') >= _.get(entry, 'user.recentSalary')
        : false
    },
    filterDesiredSalaryGte (entry) {
      return _.isNumber(_.get(entry, 'user.desiredSalary'))
        ? _.get(this.filterData, 'desiredSalary.gte') <= _.get(entry, 'user.desiredSalary')
        : false
    },
    filterDesiredSalaryLte (entry) {
      return _.isNumber(_.get(entry, 'user.desiredSalary'))
        ? _.get(this.filterData, 'desiredSalary.lte') >= _.get(entry, 'user.desiredSalary')
        : false
    },
    filterLastEducationId (entry) {
      return _.isNumber(_.get(entry, 'user.lastEducationId'))
        ? _.get(this.filterData, 'lastEducationId') >= _.get(entry, 'user.lastEducationId')
        : false
    },
    filterToeic (entry) {
      return _.isNumber(_.get(entry, 'user.toeic'))
        ? _.get(this.filterData, 'toeic') <= _.get(entry, 'user.toeic')
        : false
    },
    filterToefl (entry) {
      return _.isNumber(_.get(entry, 'user.toefl'))
        ? _.get(this.filterData, 'toefl') <= _.get(entry, 'user.toefl')
        : false
    },
    filterEnglishSkillId (entry) {
      return _.isNumber(_.get(entry, 'user.englishSkillId'))
        ? _.get(this.filterData, 'englishSkillId') <= _.get(entry, 'user.englishSkillId')
        : false
    },
    filterCanHomeMoving (entry) {
      return _.get(entry, 'user.canHomeMoving') === _.get(this.filterData, 'canHomeMoving')
    },
    filterMarried (entry) {
      return _.get(entry, 'user.married') === _.get(this.filterData, 'married')
    },
    filterHasChild (entry) {
      return _.get(entry, 'user.hasChild') === _.get(this.filterData, 'hasChild')
    },
    filterLicense (entry) {
      return _.get(this.filterData, 'licenses')
        .some(selectedId => _.includes(_.get(entry, 'user.licenses'), selectedId))
    },
    filterSkills (entry) {
      if (_.get(this.filterData, 'isCheckedAndSearchSkill')) {
        // AND検索
        return _.get(this.filterData, 'skills')
          .every(filterSkill => {
            return entry.user.skills.some(userSkill => userSkill.id === filterSkill.id && userSkill.level >= filterSkill.level)
          })
      } else {
        // OR検索
        return _.get(this.filterData, 'skills')
          .some(filterSkill => {
            return entry.user.skills.some(userSkill => userSkill.id === filterSkill.id && userSkill.level >= filterSkill.level)
          })
      }
    },
    hiraToKana (str) {
      return str.replace(/[\u3041-\u3096]/g, function (match) {
        const chr = match.charCodeAt(0) + 0x60
        return String.fromCharCode(chr)
      })
    },
    pickEntryProperty (path) {
      return _(this.entryObjects).map('entry').map(_.property(path)).uniqWith(_.isEqual).value()
    },
    updateModalItems (data, path) {
      this.$set(this.filterData, path, data.map(x => x.id))
    },
    updateModalObjects (data, path) {
      // skillsの型 [{id: 121010101, level: 12}, {id: 121010101, level: 12}]
      const skills = data.map(x => {
        return { id: x.id, level: x.experience ? Number(x.experience) : Number(this.defaultExperienceId) }
      })
      this.$set(this.filterData, path, skills)
    },
    modalSelected (dataKey, path) {
      return _.get(this[dataKey], path).map(id => { return { id: id } })
    },
    notAfterTodayAndBeforeExpiryDate (date) {
      return date > dayjs() || date <= dayjs().subtract(1, 'years').subtract(1, 'months')
    }
  }
}
</script>
